import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { message, setCurrentShow, setHistoryRoute, setRoute, setTitleAndScrollToTop } from "../../../actions";
import { createSurveys, deleteSurveys, downloadSurvey, getSurveyOverview } from "../actions/Surveys";
import { getQuestionnaires, getQuestionnairesOverview } from "../actions/Questionnaires";

import Configuration, { translations } from "../../../config";
import Form from "../../../components/Form";
import Icon from "../../../components/Icon";
import Access from "../../../components/Access";
import getFromQueryString from "../../../components/URLParams";
import ReactGA from "react-ga";
import Overview from "../../../components/Overview";

const mapStateToProps = ( state ) =>
{
	return {
		questionnairesOverview: state.questionnairesOverview,
		surveys: state.surveys,
		user: state.user,
		show: state.show,
		historyRoute: state.historyRoute
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getSurveyOverview: () =>
		{
			dispatch( getSurveyOverview() );
		},
		getQuestionnaires: ( id ) =>
		{
			dispatch( getQuestionnaires( id ) );
		},
		getQuestionnairesOverview: ( mode ) =>
		{
			dispatch( getQuestionnairesOverview( mode ) );
		},
		createSurveys: ( formData, mode ) =>
		{
			dispatch( createSurveys( formData, mode ) );
		},
		downloadSurvey: ( a_survey, a_format ) =>
		{
			dispatch( downloadSurvey( a_survey, a_format ) );
		},
		deleteSurveys: ( id ) =>
		{
			dispatch( deleteSurveys( id ) );
		},
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setTitleAndScrollToTop( title ) );
		},
		setCurrentShow: ( show ) =>
		{
			dispatch( setCurrentShow( show ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		},
		setRoute: ( a_route ) =>
		{
			dispatch( setRoute( a_route ) );
		},
		setHistoryRoute: ( a_route ) =>
		{
			dispatch( setHistoryRoute( a_route ) );
		}
	};
};

/**
 * Fragebogenkomponente der GUI
 */
class SurveysOverview extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			selectedQuestionnaireId: null,
			isExpand: {},
			test: false
		};
		
		this.handleQuestionnaireOverview = this.handleQuestionnaireOverview.bind( this );
		this.selectQuestionnaireId = this.selectQuestionnaireId.bind( this );
		this.handleExport = this.handleExport.bind( this );
		this.handleExpand = this.handleExpand.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		const questionnaireId = getFromQueryString( "id" );
		
		if ( questionnaireId )
		{
			this.selectQuestionnaireId( questionnaireId, this.props.test ? "test" : "create" );
			
			// Google Analytics
			if ( localStorage.getItem( "ga" ) )
			{
				ReactGA.pageview( `${translations.de_DE.routes.survey}/${questionnaireId}` );
			}
		}
		else
		{
			this.props.setTitleAndScrollToTop( translations.de_DE.words.surveysOverview );
			this.props.setCurrentShow( "SurveysOverview" );
			this.props.getSurveyOverview();
			
			// Google Analytics
			if ( localStorage.getItem( "ga" ) )
			{
				ReactGA.pageview( `${translations.de_DE.routes.surveys}` );
			}
			
			this.setState( { isExpand: { "Eigene Recherchen": true } } );
		}
		
	} // function componentDidMount()
	
	componentWillUnmount()
	{
		// Aufgerufene Testumfrage löschen
		sessionStorage.removeItem( "Survey" );
		
	} // function componentWillUnmount()
	
	handleQuestionnaireOverview( a_mode )
	{
		// Setze die Route wenn es sich um die Komponentenroute handelt
		if ( this.props.location.pathname === translations.de_DE.routes.surveys )
		{
			this.props.setHistoryRoute( this.props.location.pathname );
		}
		
		if ( a_mode === "test" )
		{
			this.setState( { test: true } );
		}
		
		this.props.setTitleAndScrollToTop( `${translations.de_DE.words.questionnaire} auswählen` );
		this.props.setCurrentShow( "QuestionnaireOverview" );
		this.props.getQuestionnairesOverview();
		
	} // function handleQuestionnaireOverview(...)
	
	selectQuestionnaireId( a_id, a_mode )
	{
		this.props.setCurrentShow( a_mode === "test" ? "TestSurvey" : "CreateSurvey" );
		this.setState( { selectedQuestionnaireId: a_id } );
		this.props.getQuestionnaires( a_id );
		
	} // function selectQuestionnaireId(...)
	
	handleSubmit( event, survey, mode )
	{
		let valid = true;
		switch ( mode )
		{
			case "test":
				// Pflichtfelder prüfen
				if ( survey.title.length === 0 )
				{
					this.props.message( `Bitte den ${translations.de_DE.words.surveys}titel eingeben.`, "warning", 5000 );
					valid = false;
				}
				else if ( survey.title.length > 255 )
				{
					this.props.message( `Der ${translations.de_DE.words.surveys}titel darf maximal 255 Zeichen enthalten.`, "warning", 5000 );
					valid = false;
				}
				
				if ( survey.description !== "undefined" && survey.description.length > 255 )
				{
					this.props.message( "Die Beschreibung darf maximal 255 Zeichen enthalten.", "warning", 5000 );
					valid = false;
				}
				
				if ( valid )
				{
					this.props.createSurveys( survey, mode );
					this.setState( { selectedQuestionnaireId: null } );
					this.props.setTitleAndScrollToTop( translations.de_DE.words.surveysOverview );
				}
				break;
			
			case "create":
				// Pflichtfelder prüfen
				if ( survey.title.length === 0 )
				{
					this.props.message( `Bitte den ${translations.de_DE.words.surveys}titel eingeben.`, "warning", 5000 );
					valid = false;
				}
				else if ( survey.title.length > 255 )
				{
					this.props.message( `Der ${translations.de_DE.words.surveys}titel darf maximal 255 Zeichen enthalten.`, "warning", 5000 );
					valid = false;
				}
				
				if ( survey.description !== "undefined" && survey.description.length > 255 )
				{
					this.props.message( "Die Beschreibung darf maximal 255 Zeichen enthalten.", "warning", 5000 );
					valid = false;
				}
				
				const monthlyLimit = this.props.user.organization.monthly_limit ? this.props.user.organization.monthly_limit : false;
				const price = this.props.questionnairesOverview !== null &&
				this.props.questionnairesOverview.hasOwnProperty( this.state.selectedQuestionnaireId )
					? parseFloat( this.props.questionnairesOverview[this.state.selectedQuestionnaireId].price )
					: 0;
				
				if ( monthlyLimit !== false )
				{
					if ( monthlyLimit < ( parseFloat( this.props.user.organization.survey_costs ) + parseFloat( this.props.user.organization.basic_charge ) + price ) )
					{
						this.props.message( "Das Kostenlimit Ihrer Organisation ist erreicht. Bitte wenden Sie sich an Ihren Vorgesetzten.", "warning", 5000 );
						valid = false;
					}
				}
				
				if ( valid )
				{
					this.props.createSurveys( { ...survey, price: price.toString() } );
					this.setState( { selectedQuestionnaireId: null } );
					this.props.setTitleAndScrollToTop( translations.de_DE.words.surveysOverview );
				}
				break;
			
			case "cancel":
				if ( this.props.historyRoute )
				{
					this.props.setCurrentShow( "SurveysOverview" );
					this.props.history.push( this.props.historyRoute );
					this.props.setHistoryRoute( null );
					this.props.setTitleAndScrollToTop( translations.de_DE.words.surveysOverview );
				}
				// Show zurücksetzen und auf die Startseite Umleiten
				else
				{
					this.props.setCurrentShow( null );
					this.props.history.push( "/" );
				}
				this.setState( { selectedQuestionnaireId: null } );
				break;
			
			default:
				break;
		}
		
		event.preventDefault();
		
	} // function handleSubmit()
	
	handleExport( a_event, a_survey )
	{
		this.props.downloadSurvey( a_survey );
		
		a_event.preventDefault();
		
	} // function handleExport(...)
	
	/**
	 * Einen Umfrageblock ein-/ausklappen
	 */
	handleExpand( a_id )
	{
		let is_expand = Object.assign(
			{},
			this.state.isExpand,
			{
				[a_id]: !this.state.isExpand[a_id]
			}
		);
		this.setState( { isExpand: is_expand } );
		
	} // function handleExpand(...)
	
	handlePatchSurvey( a_survey )
	{
		// this.props.setHistoryRoute( this.props.location.pathname );
		this.props.history.push( `${translations.de_DE.routes.survey}/${a_survey.id}` );
		
	} // function handlePatchSurvey(...)
	
	handleExportPDF( a_survey )
	{
		this.props.downloadSurvey( a_survey );
		
	} // function handleExportPDF(...)
	
	handleDelete( a_survey )
	{
		this.props.setTitleAndScrollToTop( `${translations.de_DE.words.surveys}übersicht` );
		this.props.deleteSurveys( a_survey.id );
		this.setState( { selectedQuestionnaireId: null } );
		this.setState( { blocksByQuestionnaireId: {} } );
		
	} // function handleExportPDF(...)
	
	render()
	{
		const price = this.props.questionnairesOverview !== null &&
		this.props.questionnairesOverview.hasOwnProperty( this.state.selectedQuestionnaireId )
			? this.props.questionnairesOverview[this.state.selectedQuestionnaireId].price
			: null;
		
		const sortedSurveys = this.props.surveys && Object.keys( this.props.surveys ).length > 0
			? Object.keys( this.props.surveys )
				.sort( ( a_key1, a_key2 ) => this.props.surveys[a_key1].user_id - this.props.surveys[a_key2].user_id )
			: null;
		
		const userSurveyIds = sortedSurveys && Object.keys( sortedSurveys ).length > 0
			? sortedSurveys.filter( ( a_key ) => this.props.surveys[a_key].user_id && this.props.surveys[a_key].user_id.toString() === this.props.user.id.toString() )
			: null;
		
		const usersSurveyIds = sortedSurveys && Object.keys( sortedSurveys ).length > 0
			? sortedSurveys.filter( ( a_key ) => this.props.surveys[a_key].user_id && this.props.surveys[a_key].user_id.toString() !== this.props.user.id.toString() )
			: null;
		
		const userSurveys = userSurveyIds ? userSurveyIds.map( a_key => this.props.surveys[a_key] ) : null;
		const usersSurveys = usersSurveyIds ? usersSurveyIds.map( a_key => this.props.surveys[a_key] ) : null;
		
		const surveyFields = [
			{
				name: "title",
				title: "Titel",
				type: "text",
				required: true,
				maxLength: "255"
			},
			{
				name: "description",
				title: "Beschreibung",
				type: "textarea",
				maxLength: "255"
			}
		];
		
		const listFields = [
			{
				type: [ "title", "description" ],
				title: [ "Titel", "Beschreibung" ],
				className: "col s12 m6 l4 xl6",
				sortable: true,
				fieldValueClassName: [ "main-text", "sub-text" ]
			},
			{
				type: "law",
				title: "Norm",
				sortable: true,
				className: "col s12 m6 l6 xl2"
			},
			{
				type: [ "created_at", "completed_at" ],
				title: [ "Erstellt am", "Geschlossen am" ],
				format: "date",
				sortable: true,
				className: "col s12 m6 l6 xl3"
			},
			{
				type: "price",
				title: "Preis",
				className: "col s12 m6 l4 xl1",
				format: "price",
				sortable: true,
				cleared: true
			}
		];
		
		return (
			<article>
				<Access permissions={[ "create_survey" ]}>
					{
						// Preis beim Formular zum Erstellen einer Umfrage anzeigen
						price !== null &&
						<div className="showablePrice current">
							<div className="price">
							<span className="value tRight white-text">
								{price && ( parseFloat( price ) ).toLocaleString( Configuration.location, Configuration.priceString )}
							</span>
								<span className="additional white-text">Euro</span>
							</div>
						</div>
					}
				</Access>
				<section className={"white"}>
					{
						// Übersicht der Umfragen
						this.props.show === "SurveysOverview" &&
						<React.Fragment>
							<div className={"col s12 tRight"}>
								<Access permissions={[ "test_survey" ]}>
									<button className={"icon-shadow margin-top btn-right-space"}
									        onClick={() => this.handleQuestionnaireOverview( "test" )}
									>
										<Icon iconName={"test"}/>
										<span>{translations.de_DE.words.surveys}test starten</span>
									</button>
								</Access>
								<Access permissions={[ "create_survey" ]}>
									<button className={"icon-shadow margin-top btn-right-space"}
									        onClick={() => this.handleQuestionnaireOverview()}
									>
										<Icon iconName={"add"}/>
										<span>Neue {translations.de_DE.words.survey} zahlungspflichtig starten</span>
									</button>
								</Access>
							</div>
							{
								// Übersicht Eigene Recherchen
								userSurveys &&
								<div className={"col s12"}>
									<Overview title={"Eigene Recherchen"}
									          list={userSurveys}
									          classNameItem={"white-grey"}
									          classNameDataBlock={"col s12 l10 unset-padding"}
									          classNameTriggerBlock={"col s12 l2 tRight"}
									          permissionsToShow={[ "get_surveys" ]}
									          expand={false}
									          listFields={listFields}
									          trigger={[
										          {
											          key: "edit",
											          icon: "edit",
											          iconTitle: `${translations.de_DE.words.survey} bearbeiten`,
											          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
											          permissions: [ "patch_survey" ],
											          confirm: false,
											          disableOnNotEmpty: "completed_at",
											          onClick: this.handlePatchSurvey.bind( this )
										          },
										          {
											          key: "pdf",
											          icon: "pdf",
											          iconTitle: "PDF erzeugen",
											          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
											          permissions: [ "export_survey" ],
											          confirm: false,
											          onClick: this.handleExportPDF.bind( this )
										          },
										          {
											          key: "delete",
											          icon: "delete",
											          submitButtonText: "Ja",
											          cancelButtonText: "Nein",
											          iconTitle: `${translations.de_DE.words.survey} löschen`,
											          iconClassName: "white red-text hover-red hover-white-text",
											          permissions: [ "delete_survey" ],
											          submitText: `Soll die ${translations.de_DE.words.survey} gelöscht werden?`,
											          onClick: this.handleDelete.bind( this )
										          }
									          ]}
									/>
								</div>
							}
							{
								// Übersicht Weitere Recherchen
								usersSurveys &&
								<div className={"col s12"}>
									<Overview title={"Weitere Recherchen"}
									          list={usersSurveys}
									          classNameItem={"white-grey"}
									          classNameDataBlock={"col s12 l10 unset-padding"}
									          classNameTriggerBlock={"col s12 l2 tRight"}
									          permissionsToShow={[ "get_surveys" ]}
									          expand
									          listFields={listFields}
									          trigger={[
										          {
											          key: "edit",
											          icon: "edit",
											          iconTitle: `${translations.de_DE.words.survey} bearbeiten`,
											          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
											          permissions: [ "patch_restricted_survey" ],
											          confirm: false,
											          disableOnNotEmpty: "completed_at",
											          onClick: this.handlePatchSurvey.bind( this )
										          },
										          {
											          key: "pdf",
											          icon: "pdf",
											          iconTitle: "PDF erzeugen",
											          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
											          permissions: [ "export_survey" ],
											          confirm: false,
											          onClick: this.handleExportPDF.bind( this )
										          },
										          {
											          key: "delete",
											          icon: "delete",
											          submitButtonText: "Ja",
											          cancelButtonText: "Nein",
											          iconTitle: `${translations.de_DE.words.survey} löschen`,
											          iconClassName: "white red-text hover-red hover-white-text",
											          permissions: [ "delete_survey" ],
											          submitText: `Soll die ${translations.de_DE.words.survey} gelöscht werden?`,
											          onClick: this.handleDelete.bind( this )
										          }
									          ]}
									/>
								</div>
							}
						</React.Fragment>
					}
					{
						// Fragebogenauswahl
						this.props.show === "QuestionnaireOverview" &&
						<Access permissions={[ "select_questionnaires" ]}>
							<div className={"col s12"}>
								{
									this.props.questionnairesOverview !== null &&
									<div className={"collection"}>
										{
											Object.keys( this.props.questionnairesOverview ).length > 0
												? Object.keys( this.props.questionnairesOverview )
													.sort( ( a_key1, a_key2 ) => this.props.questionnairesOverview[a_key1].sort_id - this.props.questionnairesOverview[a_key2].sort_id )
													.map(
														( a_key ) =>
														{
															const link = this.props.questionnairesOverview[a_key];
															
															return link.active === "1" &&
																<div className={"btn-flat primary-color-text hover-secondary-color-text collection-item"} key={`questionnaire_id_${link.id}`}
																     onClick={() => this.selectQuestionnaireId( link.id, this.state.test ? "test" : "production" )}>
																	{link.title}
																</div>;
														}
													)
												: <p>Es wurden keine Imera gefunden.</p>
										}
										<div className={"collection-item"}>
											<button key="questionnaires_overview_cancel" className={"secondary-color"}
											        onClick={( event ) => this.handleSubmit( event, {}, "cancel" )}><Icon iconName={"discard"}/><span>Abbrechen</span>
											</button>
										</div>
									</div>
								}
							</div>
						</Access>
					}
					{
						// Formular zum Erstellen einer Umfrage
						this.props.show === "CreateSurvey" &&
						<Access permissions={[ "create_survey" ]}>
							<div className={"col s12"}>
								<Form
									id={`survey_${this.state.selectedQuestionnaireId}`}
									submitValue={[
										<Icon key={`survey_${this.state.selectedQuestionnaireId}-submit-icon`} iconName={"add"}/>,
										<span key={`survey_${this.state.selectedQuestionnaireId}-submit-text`}>{translations.de_DE.words.survey} zahlungspflichtig starten</span>
									]}
									cancelValue={[
										<Icon key={`survey_${this.state.selectedQuestionnaireId}-cancel-icon`} iconName={"leave"}/>,
										<span key={`survey_${this.state.selectedQuestionnaireId}-cancel-text`}>
											{this.props.historyRoute ? "Abbrechen" : "Zurück zur Startseite"}
										</span>
									]}
									onCancel={( event ) => this.handleSubmit( event, {}, "cancel" )}
									onSubmit={( event, formData ) => this.handleSubmit( event, {
										...formData,
										questionnaire_id: this.state.selectedQuestionnaireId
									}, "create" )}
									fields={surveyFields}
									errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
								/>
							</div>
						</Access>
					}
					{
						// Formular zum Testen einer Umfrage
						this.props.show === "TestSurvey" &&
						<Access permissions={[ "test_survey" ]}>
							<div className={"col s12"}>
								<Form
									id={`survey_${this.state.selectedQuestionnaireId}`}
									submitValue={[
										<Icon key={`survey_${this.state.selectedQuestionnaireId}-submit-icon`} iconName={"test"}/>,
										<span key={`survey_${this.state.selectedQuestionnaireId}-submit-text`}>{translations.de_DE.words.surveys}test starten</span>
									]}
									cancelValue={[
										<Icon key={`survey_${this.state.selectedQuestionnaireId}-cancel-icon`} iconName={"leave"}/>,
										<span key={`survey_${this.state.selectedQuestionnaireId}-cancel-text`}>
											{this.props.historyRoute ? "Abbrechen" : "Zurück zur Startseite"}
										</span>
									]}
									onCancel={( event ) => this.handleSubmit( event, {}, "cancel" )}
									onSubmit={( event, formData ) => this.handleSubmit( event, {
										...formData,
										questionnaire_id: this.state.selectedQuestionnaireId
									}, "test" )}
									fields={surveyFields}
									errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
								/>
							</div>
						</Access>
					}
				</section>
			</article>
		);
		
	} // function render()
	
} // class

SurveysOverview = connect(
	mapStateToProps,
	mapDispatchToProps
)( SurveysOverview );

export default withRouter( SurveysOverview );